/** ISO-2 region code as a localized country name, falling back to the code when Intl cannot resolve it. */
export function formatCountryName(code: Nullable<string>, locale: string): Nullable<string> {
  if (!code) {
    return null
  }

  try {
    return new Intl.DisplayNames([locale], { type: 'region' }).of(code) ?? code
  } catch {
    return code
  }
}
